import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';

const styles = {
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  userImage: {
    width: '100px',
    height: '100px'
  },
  tag: {
    margin: '0px 10px 0px 0px',
    backgroundColor: '#fee'
  }
};

const enhance = compose(connect());

const ShopTable = enhance(
  ({
    classes,
    menuEventName,
    menuName,
    price,
    taxTypeStr,
    reducedTaxTypeStr,
    // displayAmount,
    premiumPercent,
    menuLimitTotal,
    prefectures,
    groupName,
    description,
    manual,
    menuCombo,
    gochimeshiFlag,
    createdAt,
    updatedAt,
    tags,
    image,
    isETicket
  }) => {
    return (
      <Table className={classes.detailTable}>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCellItem}>イベント名</TableCell>
            <TableCell className={classes.tableCellData}>
              {menuEventName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>メニュー名</TableCell>
            <TableCell className={classes.tableCellData}>{menuName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              チケット発行種別
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {isETicket === 1 ? '電子' : '紙印刷'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              イベントメニューの作成方
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {manual === 1
                ? 'イベントメニューのマニュアルで挿入'
                : 'イベントメニューの自動挿入'}
            </TableCell>
          </TableRow>
          {manual === 0 && (
            <>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  イベントメニューの作成方
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {menuLimitTotal === 1 ? '一円単位利用' : '一枚単位利用'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>価格</TableCell>
                <TableCell className={classes.tableCellData}>{price}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>税区分</TableCell>
                <TableCell className={classes.tableCellData}>
                  {taxTypeStr}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  軽減税率対象
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {reducedTaxTypeStr}
                </TableCell>
              </TableRow>
            </>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              プレミアム率
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {`${premiumPercent}%`}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>条件</TableCell>
            {prefectures && groupName && (
              <TableCell className={classes.tableCellData}>
                {prefectures}
                <br />
                {groupName}
              </TableCell>
            )}
            {prefectures && !groupName && (
              <TableCell className={classes.tableCellData}>
                {prefectures}
              </TableCell>
            )}
            {!prefectures && groupName && (
              <TableCell className={classes.tableCellData}>
                {groupName}
              </TableCell>
            )}
          </TableRow>
          {manual === 1 && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>回数券</TableCell>
              <TableCell className={classes.tableCellData}>
                {menuCombo === 1 ? '回数券チケット' : '回数券ではないチケット'}
              </TableCell>
            </TableRow>
          )}
          {manual === 0 && (
            <TableRow>
              <TableCell className={classes.tableCellItem}>適用対象</TableCell>
              <TableCell className={classes.tableCellData}>
                {gochimeshiFlag === 1 ? '全ごちめしシステム' : '本イベントだけ'}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={classes.tableCellItem}>説明</TableCell>
            <TableCell className={classes.tableCellData}>
              {description}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>タグ</TableCell>
            <TableCell className={classes.tableCellData}>
              <div>
                {tags &&
                  tags.map(tag => {
                    return <span className={classes.tag}>{tag.tagName}</span>;
                  })}
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>画像</TableCell>
            <TableCell className={classes.tableCellData}>
              <Card className={classes.userImage}>
                <CardActionArea>
                  <CardMedia component="img" image={image} />
                </CardActionArea>
              </Card>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>登録日時</TableCell>
            <TableCell className={classes.tableCellData}>{createdAt}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>更新日時</TableCell>
            <TableCell className={classes.tableCellData}>{updatedAt}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }
);

export default withStyles(styles)(ShopTable);
